import njWealthLogo from "../assets/association/Nj-Wealth.png";
import motilalLogo from "../assets/association/Motilal-Oswal.png";

export const PARTNER_OFFERINGS = {
  motilal: {
    key: "motilal",
    name: "Motilal Oswal",
    subtitle: "Integrated Wealth, Market & Alternatives Platform",
    logo: motilalLogo,
    route: "/motilal-oswal",
    accent: "#2563eb",
    accentEnd: "#10b981",
    intro:
      "Motilal Oswal Financial Services is an integrated financial platform with 35+ years of market experience, offering access across broking, advisory, wealth, PMS, AIF, fixed income, insurance, unlisted opportunities, and lending solutions.",
    quickHighlights: [
      "Presence across 450+ cities with 2,500+ business locations",
      "1.4 crore+ registered customers with one-platform investment access",
      "IMP Info Hub — Intelligent Model Portfolio leaflets and guides (Motilal online hub)",
    ],
    sections: [
      {
        heading: "Market Access & Trading",
        items: [
          "Equity delivery & intraday",
          "Equity Futures & Options",
          "Commodity Futures & Options",
          "Currency Futures & Options",
          "Motilal STRATX (algo & automated F&O)",
          "Global/USD products (GIFT route)",
        ],
      },
      {
        heading: "Core Investment Products",
        items: [
          "Mutual Funds (equity, hybrid, debt)",
          "Portfolio Management Services (PMS)",
          "Alternate Investment Funds (AIF Cat II & Cat III)",
          "Unlisted & pre-IPO shares",
          "Insurance (life, health, general)",
        ],
      },
      {
        heading: "AIF Platform (Navigator Offerings)",
        items: [
          "AIF Navigator (Motilal Oswal alternate investments)",
          "Category III AIFs (open/closed-ended strategies)",
          "Category II AIFs (private credit, PE, real estate)",
          "Motilal Oswal Founders Fund",
          "Motilal Oswal Hedged Equity Multifactor",
          "MO Alts India Credit Excellence Fund - I",
        ],
      },
      {
        heading: "PMS Platform (Navigator Offerings)",
        items: [
          "MOAMC Founders Strategy",
          "MOAMC Value Migration",
          "MOAMC Mid to Mega Strategy",
          "Renaissance India Next PMS",
          "Renaissance Opportunities Portfolio",
        ],
      },
      {
        heading: "IMP Info Hub — Intelligent Model Portfolios",
        items: [
          "IMP Product Guide",
          "IMP Product Brochure",
          "MO Signature Model Portfolio",
          "AlphaNext Model Portfolio",
          "Prime Model Portfolio",
          "Zodiac Model Portfolio",
          "MO Technical Focus Model Portfolio",
          "RS Alpha Bluechip Model Portfolio",
          "MO 20 Quant Momentum Model Portfolio",
          "APEX - Active NS Industry Champ Model Portfolio",
          "ASPIRE - Active NS Mid & Small Cap Model Portfolio",
          "AN Alpha Pulse Model Portfolio",
          "VS Bluechip Edge Model Portfolio",
          "MO Combined Alpha Model Portfolio",
          "ASCEND - Active NS 5Tx5T Model Portfolio",
          "MO Signia Model Portfolio",
        ],
      },
      {
        heading: "Fixed Income & Structured Solutions",
        items: [
          "Corporate fixed deposits",
          "Primary and secondary bonds",
          "Private credit and performing credit strategies",
          "Sovereign Gold Bonds and floating-rate bonds",
        ],
      },
      {
        heading: "Advisory, Wealth & Lending",
        items: [
          "Award-winning research and advisory support",
          "Private wealth management (HNI/UHNI)",
          "Portfolio monitoring, review, and restructuring",
          "Loan Against Securities (LAS)",
          "Housing finance solutions",
        ],
      },
    ],
  },
  nj: {
    key: "nj",
    name: "NJ Wealth",
    subtitle: "Distribution-Led Wealth Platform",
    logo: njWealthLogo,
    route: "/nj-wealth",
    accent: "#0d7a5f",
    accentEnd: "#0891b2",
    intro:
      "NJ Group is one of India's largest financial distribution platforms, founded in 1994 by Niraj Choksi and Jignesh Desai. Its flagship company is NJ India Invest Pvt. Ltd. The group operates across wealth management, asset management, insurance, NBFC, and technology verticals.",
    quickHighlights: [
      "SIP-focused mutual fund and long-term investment distribution",
      "Market access with equity, F&O, ETFs, and direct equity",
      "Robo tools, goal planning, and LAS via partner institutions",
    ],
    sections: [
      {
        heading: "Market Access Products",
        items: [
          "Equity delivery & intraday",
          
          "ETFs & direct equity investing",
        ],
      },
      {
        heading: "Investment Products (Core Strength)",
        items: [
          "Mutual Funds (ALL AMCs, SIP-focused)",
          "Portfolio Management Services (PMS)",
          "National Pension System (NPS)",
          "Bonds (limited via partners)",
        ],
      },
      {
        heading: "Loan / Financing Products",
        items: [
          "Loan Against Mutual Funds (LAS)",
          "Term loans / flexi loans via NBFC partners",
        ],
      },
      {
        heading: "Advisory Platform",
        items: [
          "Robo-advisory tools",
          "Goal-based investment planning",
          "Distributor-led advisory (via NJ partners)",
        ],
      },
      {
        heading: "Distribution Ecosystem",
        items: [
          "Financial product distribution platform",
          "Partner-led wealth advisory network",
          "Client portfolio tracking tools",
        ],
      },
    ],
  },
};

